export const ADMIN = 'admin'
export const USER = 'user'
export const WAREHOUSE = 'bodega'
export const SALES = 'vendedor'
export const ACCOUNTANT = 'secretaria'
export const LOGISTICS = 'motorista'
export const CUSTOMER = 'cliente'
export const YUPIUSER = 'yupiuser'